import React, { FC } from 'react'
import styled from 'styled-components'

import { SubTitle, Title, Text } from '../CssStyled'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../../interfaces'
import FunnelIcon from './Funnel'
import CurvyLine2Icon from './CurvyLine2'
import CurvyLine1Icon from './CurvyLine1'
import { Trans, lng } from '@ads/front-core/locales'
import FunnelMobileIcon from './FunnelMobile'

const SellingFunnel: FC<ISection> = ({ setActiveMenu }) => (
  <InfinityObserver callback={() => setActiveMenu('funnel')}>
    <Container>
      <TitleStyled>
        <Trans
          i18nKey="landing:sellingFunnel"
          components={{
            bold: <TitleBoldStyled bold />,
          }}
        />
      </TitleStyled>
      <Content>
        <div>
          <SubTitleStyled as="div" bold>
            {lng('landing:reachYourTargetAudience')}
          </SubTitleStyled>
          <Text>{lng('landing:reachYourTargetAudienceDescription')}</Text>
        </div>
        <div>
          <SubTitleStyled as="div" bold>
            {lng('landing:getEngagedUser')}
          </SubTitleStyled>
          <Text>{lng('landing:getEngagedUserDescription')}</Text>
        </div>
        <div>
          <SubTitleStyled as="div" bold>
            {lng('landing:generateSales')}
          </SubTitleStyled>
          <Text>{lng('landing:generateSalesDescription')}</Text>
        </div>
      </Content>
      <FunnelWrapper>
        <CurvyLine1IconWrapper>
          <CurvyLine1Icon />
        </CurvyLine1IconWrapper>
        <FunnelIcon />

        <CurvyLine2IconWrapper>
          <CurvyLine2Icon />
        </CurvyLine2IconWrapper>
      </FunnelWrapper>
      <FunnelMobileWrapper>
        <FunnelMobileIcon />
      </FunnelMobileWrapper>
    </Container>
  </InfinityObserver>
)

const Container = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: 1fr 500px;
  padding: 60px 0px 84px;
  gap: 60px;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    right: 50%;
    width: 100vw;
    margin-left: -50vw;
    margin-right: -50vw;
    bottom: 0;
    top: 0;
    background-color: #f2f3f5;
    z-index: -1;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    grid-template-columns: 1fr;
    gap: 0;
    padding-bottom: 24px;
  }
`

const TitleStyled = styled(Title)`
  grid-column: 1;
`
const TitleBoldStyled = styled(Title)`
  margin-bottom: 64px;
`

const SubTitleStyled = styled(SubTitle)`
  margin-bottom: 10px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1;
  gap: 40px;
`

const FunnelWrapper = styled.div`
  position: relative;
  grid-column: 2;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
    grid-column: 1;
    grid-row: 2;
    justify-self: center;

    svg {
      width: 300px;
    }
  }
`

const FunnelMobileWrapper = styled.div`
  display: none;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: block;
    grid-column: 1;
    grid-row: 2;
    justify-self: center;
    margin: 60px 0 84px;
  }
`

const CurvyLine1IconWrapper = styled.div`
  position: absolute;
  top: -236px;
  left: 98px;
  z-index: -1;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const CurvyLine2IconWrapper = styled.div`
  position: absolute;
  top: 152px;
  right: 202px;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

export default SellingFunnel
